// extracted by mini-css-extract-plugin
module.exports = {"taskFiles":"TaskFiles_taskFiles__2BMZw","filesHead":"TaskFiles_filesHead__3um30","empty":"TaskFiles_empty__2NUWw"};